Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var reactFeather = require('react-feather');
var core = require('@material-ui/core');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useStyles = core.makeStyles({
  chip: {
    minWidth: "90px",
    backgroundColor: function backgroundColor(isSelected) {
      return isSelected ? core.colors.green[50] : core.colors.red[50];
    },
    "&:active, &:hover, &:focus": {
      backgroundColor: function backgroundColor(isSelected) {
        return isSelected ? core.colors.green[100] : core.colors.red[100];
      }
    }
  },
  xIcon: {
    color: core.colors.red[500],
    height: "20px",
    width: "20px"
  },
  checkIcon: {
    color: core.colors.green[500],
    height: "20px",
    width: "20px"
  }
});
var PostcodeChip = function PostcodeChip(_a) {
  var _b = _a.isSelected,
    isSelected = _b === void 0 ? false : _b,
    _c = _a.onClick,
    onClick = _c === void 0 ? function () {} : _c,
    _d = _a.disabled,
    disabled = _d === void 0 ? false : _d,
    postcode = _a.postcode;
  var classes = useStyles(isSelected);
  return React__default['default'].createElement(core.Chip, {
    className: classes.chip,
    clickable: true,
    deleteIcon: isSelected ? React__default['default'].createElement(reactFeather.Check, {
      className: classes.checkIcon,
      "data-test": "check-icon"
    }) : React__default['default'].createElement(reactFeather.X, {
      className: classes.xIcon,
      "data-test": "cross-icon"
    }),
    "aria-checked": isSelected,
    label: postcode,
    onClick: onClick,
    onDelete: onClick,
    disabled: disabled,
    "data-test": "postcode-chip"
  });
};
exports.default = PostcodeChip;